<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="2140.000000pt" height="1942.000000pt" viewBox="0 0 2140.000000 1942.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,1942.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M5285 16815 c-180 -38 -280 -66 -440 -123 -803 -288 -1420 -910
-1680 -1694 -29 -90 -65 -215 -79 -279 l-26 -116 0 -615 0 -615 355 -3919
c196 -2156 367 -4009 381 -4119 84 -662 200 -1105 389 -1490 126 -257 251
-431 441 -615 368 -356 807 -544 1494 -637 116 -16 451 -17 4610 -20 l4485 -3
129 26 c849 171 1435 637 1771 1409 142 326 251 737 319 1205 14 96 224 2026
466 4288 l440 4112 0 578 0 578 -29 119 c-105 430 -337 835 -661 1155 -379
375 -850 626 -1460 776 l-115 29 -5315 2 -5315 2 -160 -34z m10545 -448 c480
-84 792 -199 1115 -411 529 -348 842 -843 920 -1455 35 -275 51 -110 -449
-4766 -250 -2337 -467 -4331 -481 -4430 -104 -737 -295 -1251 -600 -1613 -336
-401 -870 -625 -1575 -661 -195 -10 -7989 36 -8300 49 -727 30 -1181 197
-1524 562 -323 343 -511 853 -631 1713 -14 99 -199 2090 -411 4425 l-385 4245
11 157 c35 518 192 941 487 1315 88 112 290 306 412 397 329 245 699 391 1172
463 105 16 302 17 2434 23 1276 3 3533 5 5015 5 2468 -1 2703 -3 2790 -18z"/>
<path d="M8655 15789 c-125 -18 -257 -72 -356 -145 -123 -90 -236 -244 -283
-385 -45 -135 -47 -176 -44 -860 4 -720 2 -694 78 -854 79 -166 202 -290 365
-371 177 -87 -40 -79 2195 -82 2197 -3 2062 -7 2220 61 264 114 442 351 480
637 8 58 10 287 8 710 -5 692 -3 673 -73 827 -82 179 -218 315 -398 398 -163
75 24 69 -2167 71 -1086 1 -1992 -2 -2025 -7z m4035 -395 c120 -58 204 -153
241 -274 19 -63 19 -91 17 -701 l-3 -635 -37 -75 c-67 -136 -185 -225 -328
-249 -45 -7 -652 -10 -1975 -8 -1792 3 -1913 4 -1961 21 -129 44 -242 155
-283 280 -21 63 -22 75 -19 708 l3 644 32 67 c54 115 148 198 268 240 47 16
170 17 2015 15 l1965 -2 65 -31z"/>
<path d="M9593 14966 c-174 -44 -299 -179 -339 -364 -18 -86 -18 -248 1 -335
31 -149 113 -261 228 -312 80 -37 232 -47 319 -21 108 31 204 119 229 209 20
68 15 175 -11 235 -26 60 -91 124 -158 155 -40 18 -65 22 -172 22 -110 0 -131
-3 -175 -23 -27 -13 -65 -37 -82 -54 l-33 -32 0 56 c0 31 9 86 21 124 27 89
106 171 188 197 67 21 201 22 256 1 22 -8 47 -18 55 -20 11 -4 24 12 43 52 33
67 30 73 -48 99 -66 23 -252 29 -322 11z m198 -563 c66 -34 99 -85 99 -155 0
-123 -84 -197 -226 -198 -138 0 -229 75 -229 190 0 45 6 65 27 97 61 92 216
123 329 66z"/>
<path d="M11595 14967 c-157 -40 -235 -132 -235 -275 0 -85 27 -142 89 -189
23 -18 37 -33 31 -33 -26 0 -101 -64 -127 -108 -25 -42 -28 -57 -28 -137 0
-73 4 -98 22 -130 44 -83 135 -143 250 -165 93 -18 274 -8 345 19 160 62 238
204 194 354 -19 65 -53 109 -114 148 l-43 27 31 18 c82 49 121 175 88 288 -18
60 -99 137 -173 166 -74 28 -252 37 -330 17z m275 -148 c33 -17 51 -37 68 -71
21 -41 22 -51 12 -89 -15 -56 -55 -94 -120 -113 -99 -30 -201 -16 -264 35 -92
76 -61 208 59 254 62 23 189 15 245 -16z m13 -442 c74 -34 102 -75 102 -149 0
-63 -19 -97 -75 -136 -49 -33 -104 -44 -199 -40 -99 4 -167 31 -202 80 -23 32
-35 101 -25 142 8 33 51 83 88 102 78 41 224 41 311 1z"/>
<path d="M10230 14968 c0 -2 -11 -113 -25 -248 -14 -135 -25 -257 -25 -271 l0
-27 188 -4 c199 -5 251 -16 301 -61 81 -75 63 -206 -36 -264 -44 -26 -56 -28
-153 -28 -118 1 -183 19 -263 74 -50 34 -47 36 -91 -42 -15 -26 -24 -52 -21
-58 12 -19 81 -57 155 -84 99 -37 271 -46 370 -21 160 41 245 149 245 311 0
69 -4 88 -30 140 -58 115 -161 162 -377 172 -83 4 -128 10 -128 17 0 6 5 66
12 134 l11 122 229 0 228 0 0 70 0 70 -295 0 c-162 0 -295 -1 -295 -2z"/>
<path d="M11019 14101 c-23 -24 -29 -38 -29 -75 0 -62 30 -96 91 -103 38 -4
50 -1 77 22 29 24 32 32 32 80 0 47 -4 56 -31 79 -44 37 -101 36 -140 -3z"/>
<path d="M14712 14159 c-193 -28 -418 -173 -576 -371 -70 -87 -1051 -1662
-1127 -1808 -32 -63 -64 -106 -124 -166 -121 -121 -264 -186 -445 -202 -47 -4
-859 -5 -1805 -2 l-1720 5 -82 23 c-201 53 -349 134 -456 246 -43 45 -190 271
-555 853 -273 436 -522 834 -552 884 -61 102 -188 243 -283 315 -83 62 -225
129 -327 154 -84 21 -102 21 -1324 20 -860 -1 -1245 -4 -1260 -12 -43 -22 -56
-49 -56 -123 0 -38 11 -353 25 -700 20 -484 29 -638 40 -663 31 -69 129 -81
179 -21 24 29 26 37 25 137 0 59 -10 343 -23 632 -13 289 -22 526 -21 527 1 2
514 3 1141 3 825 1 1154 -2 1194 -11 194 -41 384 -189 510 -397 178 -295 1027
-1639 1074 -1700 131 -168 366 -305 626 -363 171 -38 306 -40 2045 -37 1854 4
1708 -1 1895 68 211 76 380 225 474 417 40 81 985 1610 1064 1722 105 148 275
286 407 329 58 19 100 20 1253 23 1172 4 1194 4 1208 -15 8 -11 14 -41 14 -67
0 -27 -164 -1982 -365 -4346 -298 -3503 -370 -4321 -390 -4421 -78 -381 -268
-730 -515 -940 -209 -177 -465 -287 -750 -322 -70 -8 -1245 -10 -4520 -8
l-4425 3 -87 22 c-435 109 -746 320 -970 658 -111 168 -211 409 -258 622 -14
64 -80 861 -239 2878 -122 1535 -223 2809 -226 2832 -11 79 -90 123 -162 89
-72 -34 -86 223 162 -2912 130 -1633 232 -2863 241 -2909 74 -366 252 -717
488 -963 290 -302 700 -498 1135 -542 139 -14 8638 -14 8801 0 562 49 986 302
1271 760 145 233 265 569 298 835 23 181 735 8583 735 8670 0 136 -45 219
-148 273 l-51 27 -1200 1 c-673 1 -1228 -2 -1263 -7z"/>
<path d="M13858 12149 c-219 -29 -388 -175 -451 -387 -17 -55 -35 -235 -39
-384 -3 -70 0 -88 12 -91 8 -2 25 -35 38 -74 62 -194 182 -283 366 -271 120 8
229 78 341 220 110 140 166 270 187 435 14 110 1 253 -33 353 -30 88 -103 162
-180 184 -74 20 -161 26 -241 15z"/>
<path d="M7208 12077 c-77 -18 -146 -63 -185 -121 -40 -59 -50 -94 -65 -222
-26 -224 44 -434 210 -638 150 -184 348 -251 519 -176 91 39 142 110 190 267
25 81 27 102 27 258 0 159 -2 175 -26 243 -69 192 -211 330 -389 378 -78 21
-214 26 -281 11z"/>
<path d="M14750 11942 c-260 -70 -376 -325 -286 -627 9 -27 30 -75 48 -105
109 -180 316 -185 488 -11 218 221 227 624 16 733 -57 29 -178 34 -266 10z"/>
<path d="M6300 11831 c-128 -39 -184 -136 -184 -316 0 -175 59 -310 190 -435
107 -101 218 -133 338 -98 61 19 126 88 158 173 121 310 5 599 -267 670 -61
16 -191 19 -235 6z"/>
<path d="M15411 11554 c-100 -35 -176 -108 -211 -201 -56 -151 2 -374 118
-454 54 -36 148 -34 220 6 102 56 188 181 211 309 15 80 14 121 -4 191 -18 69
-56 122 -106 147 -43 23 -166 23 -228 2z"/>
<path d="M5723 11420 c-74 -11 -117 -41 -147 -103 -47 -99 -43 -242 11 -355
35 -74 122 -165 191 -199 147 -72 278 -6 329 166 24 81 21 211 -6 282 -41 107
-140 190 -243 204 -24 4 -52 8 -63 9 -11 2 -43 0 -72 -4z"/>
<path d="M16005 11191 c-58 -14 -106 -44 -149 -93 -61 -67 -79 -127 -74 -238
3 -73 9 -98 36 -153 41 -83 76 -110 152 -115 109 -8 219 70 278 196 24 51 27
68 27 173 0 110 -1 117 -28 158 -46 69 -139 97 -242 72z"/>
<path d="M5130 10997 c-67 -35 -85 -78 -85 -207 0 -99 2 -110 33 -172 56 -115
156 -181 274 -182 76 -1 87 6 164 106 42 54 44 59 44 126 0 114 -44 224 -114
285 -79 69 -230 90 -316 44z"/>
<path d="M14201 10889 c-455 -47 -732 -252 -848 -626 -26 -84 -27 -98 -27
-293 0 -174 3 -219 22 -298 36 -155 246 -636 398 -912 184 -335 272 -550 319
-785 70 -348 57 -592 -54 -1026 -51 -200 -138 -596 -166 -757 -61 -351 -59
-721 4 -969 44 -172 128 -372 201 -478 164 -239 401 -364 687 -365 415 0 714
195 904 594 134 281 197 572 239 1106 72 915 211 1618 468 2355 90 258 129
444 151 720 47 592 -235 1029 -904 1403 -272 152 -590 265 -880 312 -143 24
-384 32 -514 19z"/>
<path d="M6805 10803 c-484 -59 -901 -245 -1351 -604 -304 -242 -473 -505
-529 -823 -19 -112 -20 -340 -1 -466 33 -214 112 -476 256 -840 243 -617 379
-1138 475 -1820 60 -422 159 -917 227 -1130 64 -202 178 -394 320 -538 119
-121 252 -200 413 -243 114 -32 345 -32 460 -1 180 49 359 163 472 302 207
254 299 763 223 1226 -43 260 -150 694 -248 1010 -106 338 -135 503 -135 764
1 343 72 628 241 965 33 66 82 170 110 231 66 145 292 681 292 693 0 5 -5 11
-11 13 -8 3 -8 24 1 78 35 224 30 420 -15 574 -97 335 -352 544 -735 602 -86
13 -382 18 -465 7z"/>
<path d="M16379 10686 c-105 -37 -162 -128 -162 -257 1 -152 75 -249 191 -249
84 0 164 65 214 176 31 68 32 201 3 259 -30 60 -75 85 -149 85 -34 -1 -77 -7
-97 -14z"/>
<path d="M4779 10487 c-19 -12 -44 -42 -57 -67 -20 -39 -23 -55 -19 -122 14
-213 179 -352 331 -278 81 39 118 137 97 260 -14 88 -40 141 -85 175 -75 57
-206 73 -267 32z"/>
</g>
</svg>
